/**
 * Frontend half of the Short Question contract. These rules mirror
 * api/src/app/helpers/report.ts exactly — the backend is the authority (it
 * caps on write and re-derives every sheet header), this file only stops the
 * UI from showing or submitting a label the backend would then trim.
 */
export const SHORT_QUESTION_MAX_LENGTH = 30;

const normalizeLabel = (value?: string | null): string =>
  String(value ?? "")
    .replace(/\s+/g, " ")
    .trim();

/** Enforce the cap on an admin-supplied Short Question. */
export const capShortQuestion = (
  shortQuestion?: string | null,
  maxLength: number = SHORT_QUESTION_MAX_LENGTH
): string => normalizeLabel(shortQuestion).slice(0, maxLength);

/**
 * Truncate a question name down to the cap, marking the cut with "..." inside
 * the budget so the result is never longer than maxLength.
 */
export const truncateToShortQuestion = (
  name?: string | null,
  maxLength: number = SHORT_QUESTION_MAX_LENGTH
): string => {
  const normalized = normalizeLabel(name);
  if (normalized.length <= maxLength) return normalized;
  if (maxLength <= 3) return normalized.slice(0, maxLength);
  return `${normalized.slice(0, maxLength - 3)}...`;
};

/** The label shown in the export popup and the report table header. */
export const resolveShortQuestion = (
  shortQuestion?: string | null,
  name?: string | null,
  maxLength: number = SHORT_QUESTION_MAX_LENGTH
): string =>
  capShortQuestion(shortQuestion, maxLength) ||
  truncateToShortQuestion(name, maxLength);

/** Subject-detail keys ticked when the export popup first opens. */
export const DEFAULT_REPORT_SUBJECT_FIELD_KEY_LIST = ["name", "age"];
